import { theme } from 'theme'
import styled from 'particles/themes/styled'
const PopupInputContainer = styled.div`
    position: fixed;
    background-color: rgba(1, 1, 1, 0.5);
    top: 0;
    left: 0;
    width: 100vw;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 130;
    .input-area-outer-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 400px;
        height: 320px;
        background-color: white;
        box-shadow:
            0px 8px 10px -5px rgba(0, 0, 0, 0.2),
            0px 16px 24px 2px rgba(0, 0, 0, 0.14),
            0px 6px 30px 5px rgba(0, 0, 0, 0.12);
        border-radius: 4px;
        padding: 51px 24px 21px;
        .popup-title {
            display: flex;
            justify-content: space-between;
            font-size: ${theme.newFontSizes.xl};
            font-weight: ${theme.fontWeight.bold};
            margin-bottom: 40px;
            svg {
                cursor: pointer;
            }
        }
        .input-block {
            display: flex;
            flex-direction: column;
            .input-title {
                font-size: ${theme.newFontSizes.s};
                color: ${theme.colors.mineShaft};
                margin-bottom: 8px;
            }
        }
        .custom-error {
            padding-left: 8px;
            font-size: 0.8em;
            color: red;
        }
        .table-button {
            display: flex;
            justify-content: flex-end;
            margin-top: 10px;
            justify-self: flex-end;
            button:first-child {
                margin-right: 32px;
            }
        }
    }
`
export default PopupInputContainer
